<div class="iframe-container">
  <iframe crossorigin="anonymous" [src]="safeUrl" frameborder="0" allowfullscreen> </iframe>
</div>
